/*
 * Copyright (c) Nexign, JSC, 2021.
 */
/**
 *
 *
 * @author Yakov Gushchin
 * @version 1.13.0
 * @since 1.13.0
 */

import { Fragment } from 'react';

import { useSelector } from 'react-redux';

import { makeSelectTranslationCommon } from '../../../../../modules/internationalization/intSelectors';
import { useSubscriberIdContext } from '../../../context';
import { dcRuleScheduleListSelector, dcRulesTranslationSelector } from '../selectors';


const SubscriberIdDcRuleSchedule = () => {

    const { subscriberId } = useSubscriberIdContext();

    const { schedule: tSchedule } = useSelector(dcRulesTranslationSelector());
    const { calendar: tCalendar } = useSelector(makeSelectTranslationCommon());

    const scheduleList = useSelector(dcRuleScheduleListSelector(subscriberId));

    if (!scheduleList?.length) return null;

    return (
        <div className="subscriber-dc-rules__schedule">
            <div className="subscriber-dc-rules__title-block">
                <div className="subscriber-id__title subscriber-id__title_bold subscriber-dc-rules__schedule-title">
                    {tSchedule.title}
                </div>
                <div className="subscriber-id__title subscriber-id__title_light">
                    {tSchedule.subTitle}
                </div>
            </div>
            <div className="subscriber-dc-rules__schedule-list">
                {
                    scheduleList.map(schedule => (
                        <Fragment key={schedule.day}>
                            <div className="subscriber-dc-rules__schedule-date">
                                {tCalendar.weeks[schedule.day]}
                            </div>
                            <div className="subscriber-dc-rules__schedule-separate"/>
                            <div className="subscriber-dc-rules__schedule-time">
                                {schedule.time
                                    ? `${schedule.time.start} - ${schedule.time.end}`
                                    : tSchedule.noTime
                                }
                            </div>
                        </Fragment>
                    ))
                }
            </div>
        </div>
    );
};

export default SubscriberIdDcRuleSchedule;
